import {apiSlice} from './baseApi';
import {
  GetAlertParametersTypeParams,
  AlertParametersTypeModel, AlertParametersModel,
} from '../../types/api/alertParameters';

const alertParametersApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAlertParametersType: build.query<AlertParametersTypeModel[], Partial<GetAlertParametersTypeParams>>({
      query: (params) => ({
        url: '/alert-parameter-types/',
        method: 'GET',
        params: {...params}
      })
    }),
    getSingleAlertParameterType: build.query<AlertParametersTypeModel, string>({
      query: (uuid) => ({
        url: `/alert-parameter-types/${uuid}/`,
        method: 'GET'
      })
    }),
    getAlertParameters: build.query<AlertParametersModel, string>({
      query: (uuid) => ({
        url: `/alert-parameters/${uuid}/`,
        method: 'GET'
      })
    }),
    updateAlertParameters: build.mutation<AlertParametersModel, Partial<AlertParametersModel>>({
      query: ({uuid, ...params}) => ({
        url: `/alert-parameters/${uuid}/`,
        method: 'PATCH',
        body: {...params}
      }),
      invalidatesTags: ['Asset']
    })
  })})

export const {
  useGetAlertParametersTypeQuery,
  useUpdateAlertParametersMutation
} = alertParametersApi